<template>
    <div>
      <b-row>
    <b-col md="12">   
    <b-table
      :ref="refTable"
      
      :items="items"
      :fields="fFields"
      responsive
      :per-page="pPage"
      class="medezTables cutescroll"    
      :show-empty="showMessageIsEmpty"
      :current-page="currentPage"   
      @row-clicked="LocalrowClicked" 
      @row-selected="rowSelected"    
      @row-dblclicked="ondblClicked"              
      :tbody-tr-class="tbodyRowClass"
      :id="refTable"
      :tbody-tr-attr="tbodyRowAttr"
      :sort-compare="Compare"
      :empty-text="$t('MdTable.nRecShow')"
    >


     <template v-if="editIconEvent || deleteIconEvent || viewIconEvent || UploadIconEvent || otherIconEvent || iconSelected && this.items.length > 0" #cell(actions)="row">              

        <b-tooltip v-if="viewIconEvent" :target="'ViewIcon-'+row.index"  placement="top" :delay="{ show: 1500, hide: 50 }">
          {{hintViewIcon ? hintViewIcon : $t('Shared.View')}}
        </b-tooltip>
         <b-tooltip v-if="otherIconEvent" :target="'PrintIcon-'+row.index"  placement="top" :delay="{ show: 1500, hide: 50 }">
            {{otherIcon === 'printer-fill' ? $t('Shared.Report') : 'Other Icon' }}
          </b-tooltip>
        <b-icon v-if="editIconEvent && isReadOnly && VisibleEditIcon"  icon="eye-fill" @click="editButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Edit')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
       
          <b-tooltip v-if="IsEligibility && row.item.eligibility != '' && row.item.isEligible == 'Eligible'" :target="'ViewIconEligibility-'+row.index"  placement="top" :delay="{ show: 1000, hide: 50 }">
              {{$t('View Eligibility')}}
          </b-tooltip>

           
       <span v-if="iconSelected && !isReadOnly" :class="row.item.selected ? 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTNChecked' : 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTN'"></span>
      <!--<span v-if="iconSelected && !isReadOnly" class="rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTNChecked"></span>--> 
      
       
       <!--<b-icon v-if="editIconEvent && !isReadOnly && VisibleEditIcon" icon="pencil-fill" @click="editButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Edit')" class="rounded-circle tableActionBTN" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
        <span v-b-tooltip.hover.top="$t('Shared.Edit')" btn="EditIcon" v-if="editIconEvent && !isReadOnly && VisibleEditIcon" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-pen'" @click="editButton(row.item)"></span>
      
      
        <b-icon v-if="emailIconEvent && !isReadOnly" icon="share-fill" @click="emailButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Email')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
        <!--<b-icon v-if="deleteIconEvent && !isReadOnly && VisibleDeleteIcon"  icon="trash-fill" @click="deleteButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Delete')" class="rounded-circle tableActionBTN-danger ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
       <span v-b-tooltip.hover.top="$t('Shared.Delete')" v-if="deleteIconEvent && !isReadOnly && VisibleDeleteIcon" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-bin'" @click="deleteButton(row.item)"></span>
       

       <!-- <b-icon :id="'ViewIcon-'+row.index" v-if="viewIconEvent" icon="play-fill" @click="viewButton(row.item, $event.target)" :class="isMedicationInbox && row.item.allowToReceive == false ? 'rounded-circle tableActionBTN mr-2 iconDisabled btndisabled':'rounded-circle tableActionBTN mr-2'" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
        <span :id="'ViewIcon-'+row.index" btn="ViewIcon" v-if="viewIconEvent" @click.stop="viewButton(row.item,$event)"  :class="isMedicationInbox && row.item.allowToReceive == false ? 'rounded-circle tableActionBTN tableBTNtext ikon med-play-mini iconDisabled btndisabled':'rounded-circle tableActionBTN tableBTNtext ikon med-play-mini'"></span>


       <span v-b-tooltip.hover.top="'Upload'" btn="ViewIcon" v-if="UploadIconEvent && !isReadOnly && VisibleUploadIcon" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-cloud-upload-fill'" @click="Upload(row.item)"></span>
       
       
       
       
        <b-icon v-if="Warning && row.item.warningList.length > 0" id="tWarning" icon="exclamation-triangle-fill" @click="WarningLocal(row.item, $event.target)" class="rounded-circle tableActionBTN ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
        <b-icon v-if="Error && row.item.errorList.length > 0" id="tError" icon="wrench" @click="ErrorLocal(row.item, $event.target)" class="rounded-circle tableActionBTN ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
       
       
       <!-- <b-icon v-if="otherIconEvent" :icon="otherIcon" @click="otherButton(row.item, $event.target)" v-b-tooltip.hover.top="$t('Shared.Report')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon> -->                    
       <span :id="'PrintIcon-'+row.index"  v-if="otherIconEvent" :icon="otherIcon" @click.stop="otherButton(row.item, $event.target)" class="rounded-circle tableActionBTN tableBTNtext ikon med-print"></span>
              
        <a :href="row.item.zoomStartURL" target="_blank" class="dashLink dashURL">
            <span v-b-tooltip.hover.top="$t('schedule-editor.sMeetingNow')"  v-if="showTeleHealthIcon && row.item.zoomStartURL != null" class="rounded-circle tableActionBTN tableBTNtext ikon med-videocall"></span>
        </a>


         

      <span v-on:click="InfoEvent(row.item)" v-b-tooltip.hover.top="'Drug Information'" btn="ViewIcon" v-if="isDrugOrders && ShowInfoMed" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-help'"></span>
      
      <span :id="'ViewIconEligibility-' + row.index" v-if="IsEligibility && row.item.eligibility != '' && (row.item.isEligible == 'Y' || row.item.isEligible == 'N') " :class="!row.item.eligibilityDate ? 'rounded-circle tableActionBTN tableBTNtext ikon med-report btndisabled': 'rounded-circle tableActionBTN tableBTNtext ikon med-report'" @click="viewEligibility(row.item)"></span>

     </template>


     <template #cell(report)="row">
          <div >
            <b-button v-on:click="DoReport('DCSUpload', row, row.item)" size="sm" class="repDateNotesBtn">{{ $t('Shared.Report') }}</b-button>
          </div>
     </template>

    <template v-if="IsInsurancePrior" #cell(status)="row" class="dateNotes">            
      <div>
        <span v-if="row.item.status === 'Active'" class="DocumentExpired">{{$t('Shared.Active')}}</span>
        <span v-else>{{ $t('Shared.Inactive') }}</span>
      </div>     
    </template>
  
     <template v-if="this.isSchedulerDB" #cell(startDate)="row" class="dateNotes">            
        {{row.item.startDate}}
          <div>
            <div class="pushItDown" v-if="row.item.status === 'Showed Up'"></div>
            <div v-bind:class="row.item.status === 'Showed Up'  ? 'chRstatusfinished completeDraft':'chRstatus mt-2'">
              {{row.item.status}}
            </div>
          </div>
     </template>

     <template v-if="this.isMedicationInbox" #cell(issuedDate)="row" class="dateNotes">            
      {{row.item.issuedDate}}
        <div class="pushItDown" v-if="row.item.status === 'RECEIVED'"></div>
          <div v-bind:class="row.item.status === 'RECEIVED' ? 'chRstatusfinished':'chRstatus mt-2'">
            {{$t('BadgeStatusIn.'+row.item.status)}}
          </div>
     </template>  

      <template  #cell(isUploaded)="row">            
                <!-- Tabla de Admission -->
                  <div v-if="IsDCSUpload">
                    <span v-if="row.item.isUploaded === 'Y' || row.item.isUploaded === true" class="DocumentExpired">
                      {{ $t('Uploaded') }}
                    </span>
                    <span v-else-if="row.item.isUploaded === 'F'" class="DocumentExpired" style="background-color: red; color: white !important;">{{ $t('Failed') }}</span>
                  </div>
      </template>


      <template v-if="isDrugOrders" #cell(issuedDateDrugOrder)="row" class="dateNotes">                   
        {{ row.item.issuedDateDrugOrder }}<br>
          <div class="pushItDown" v-if="row.item.internalStatus === 'ORDERED'"></div>
          <div v-bind:class="row.item.internalStatus === 'ORDERED' ? 'chRstatusfinished':'chRstatus mt-2'">
            {{$t('Shared.'+row.item.internalStatus)}}
          </div>
      </template>

      <template v-if="isDrugOrders" #cell(drugName)="row" class="dateNotes">                   
        {{ row.item.drugName }}<br>
          <div class="pushItDown"></div>
          <div v-if="row.item.isHighAlert" class="DrugOrderType doiHighAlert">
            {{ $t('modalMarsMed.isHighAlert') }}
          </div>

          <div v-if="row.item.isLookAlikeSoundAlike" class="DrugOrderType dotLASA">
           {{ $t('DrugOrdersInboxFill.LASA') }}
          </div>          

          <div :class="row.item.mode === 'STAT' ? 'DrugOrderType dotSTAT' : 'DrugOrderType'">
           {{row.item.mode}}
          </div>
        
           <div v-if="row.item.drugType" v-bind:class=" (row.item.drugType === 'C' || row.item.drugType === 'CD' || row.item.drugType === 'SCD') ? 'DrugOrderType dotCD-SCD' : 'DrugOrderType'">
            {{row.item.drugTypeDescriptionTranslated}}
          </div>
      </template>

      <template v-if="isDrugOrders" #cell(rxStatus)="row" class="dateNotes"> 
          <div :class="(row.item.rxStatus === 'Inactive' || row.item.rxStatus === 'Void')  ? 'DrugOrderType doiHighAlert':''">
           {{ row.item.rxStatus }}
          </div>       
      </template>

     <template v-if="IsItemReceived" #cell(expirationDate)="row" class="dateNotes">      
          {{ formatDate(row.item.expirationDate) }}<br>
          <div class="pushItDown"></div> 
            <span v-if="new Date(row.item.expirationDate) < new Date()" class="DocumentExpired DocumentExpiredRed">
              {{$t('MdTable.ExpiredTxt')}}
            </span>
    </template>


       <template v-if="IsDCSUpload" #cell(isUploaded)="row" class="dateNotes">                    
        {{ row.item.transDate }}<br>
          <div class="pushItDown" v-if="row.item.isUploaded"></div>
          <div v-bind:class="'mt-2'">
             <span v-if="row.item.isUploaded == 'Y'" class="DocumentExpired">Uploaded</span>
             <span v-if="row.item.isUploaded == 'E'" class="DocumentExpired" style="background-color: red; color: white !important;">Error</span> 
             <span v-else class="chRstatus">Not Uploaded</span>
          </div>
      </template>

      <template v-if="IsEligibility" #cell(eligibilityDate)="row" class="dateNotes">                    
        {{ row.item.eligibilityDate }}<br>
          <div class="pushItDown" v-if="row.item.isEligible"></div>
          <div v-bind:class="'mt-2'">
             <span v-if="row.item.isEligible == 'Y'" class="DocumentExpired">Report Created</span>
             <span v-if="row.item.isEligible == 'E'" class="DocumentExpired" style="background-color: red; color: white !important;">Error</span> 
             <span v-if="row.item.isEligible == 'N'" class="DocumentExpired" style="background-color: red; color: white !important;">Insurance Inactive</span>
             <span v-if="row.item.isEligible == 'M'" class="DocumentExpired" style="background-color: orange; color: white !important;">Missing Eligibility Payor ID</span>
             <span v-else class="chRstatus"></span>
          </div>
        </template>

    </b-table>
      <b-row dir="ltr">
      <b-col v-if="pageOptions" sm="7" md="6" class="my-1">
        <b-pagination 
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pPage"
          align="fill"
          size="sm"
          class="my-0"
          @change="fpageChanged"
        ></b-pagination>
      </b-col>
      <b-col v-if="pageOptions" align="right" class="mr-2">
          <b-form-group
            >{{ $t('Shared.Show') }}
              <b-form-select
                v-model="pPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                style="width:auto;"
                @change="pageFunction($event)"
              ></b-form-select>
              {{ $t('Shared.Of') }} {{totalRows}}
            </b-form-group>
        </b-col>
      </b-row>
        </b-col>
      </b-row>


      <NotesRep v-if="isReportVisible" 
        :closeWindow="closeRepWindow"
        :HeaderId="this.repHeaderId"
        :FormId="this.repFormId"
        :PatientCode="this.repPatientCode"
        :isReportVisible="isReportVisible"
        :ReportTitle="this.repTitle"
        :Transdate="this.repTransdate" 
        :Notetime="this.repNotetime" 
        :Void="this.repVoid"
        :NoteName="this.repNoteName"
    />

    </div>
   
  
  
</template>

<script>

import { EventBus } from '../../../event-bus.js';
import Utils from '@/common/utils'
import DBFunctions from '@/common/DBFunctions.js'
import moment from 'moment'

export default {
  name: 'MdTablePaginationClient',  
   props: {
     fields:Array,    
     items:  Array, 
     perPageFunction: Function,
     perPage: Number,
     pageChanged: Function,   
     totalRows:Number,  
     onRowSelected: Function, 
     editIconEvent: Function,
     deleteIconEvent: Function, 
     ShowDetails:Boolean,
     showMessageIsEmpty:Boolean,
     otherIconEvent: Function,
     otherIcon: String,
     viewIconEvent: Function,
     InfoIconEvent: Function,
     Error: Function,
     Warning: Function,    
     refTable: String,
     RowClick:Function,   
     isReadOnly:Boolean,
     IsInsurancePrior:Boolean,
     VisibleDeleteIcon:Boolean,
     VisibleDownloadIcon:Boolean,
     VisibleViewIcon:Boolean,
     VisibleEditIcon:Boolean,
     tbodyRowAttr: Function,
     isSchedulerDB:[Boolean],
     IsDCSUpload: [Boolean],
     FieldsDate:Array,
     ondblClick:Function,
     emailIconEvent: Function,
     showTeleHealthIcon: Boolean,
     hintViewIcon:String,
     isMedicationInbox: Boolean,
     iconSelected:Function,
     isDrugOrders: Boolean,
     UploadIconEvent:Function,    
     VisibleUploadIcon:Boolean,
     ShowInfoMed:Boolean,
     IsItemReceived:Boolean,
     IsEligibility: [Boolean],
     ViewEligibility: Function,
   },
    mixins: [EventBus,DBFunctions],
  data(){
    return{  
        pageOptions: [5,10,15,20,30,40,50],
        //perPage: 10,
        pPage: this.perPage,
         isReportVisible: false, 
        itemlocal:this.items,
        cPage:1,
        NotePatientInfo:{},
        currentPage: 1, 
         fFields: this.fields,  
          repHeaderId: '',
          repFormId: '',
          repPatientCode: '',
          repTransdate: '',
          repNotetime: '',
          repVoid: false,
          repTitle: '',
          repNoteName: '',    
    }
  },

  methods: {

    formatDate(value){
      return Utils.formatterDateToString(value)
    },

    emailButton(row) {
      this.emailIconEvent(row);
    },

       async getPatientInfo(PatientCode){
            this.NotePatientInfo = await this.getData(PatientCode);
        },

     getReportTitle(note, firstname, lastname, patientcode) {
        let reportTitle = `${note.length > 50 ? note.substring(0,50) + '...' : note} - ${firstname} ${lastname}`
        reportTitle = reportTitle.length + patientcode.length <= 100 ? `${reportTitle} - ${patientcode}` : `${reportTitle}`
        return reportTitle
      },
       closeRepWindow() {
        this.isReportVisible = false
      },
   async DoReport(location, row, item){
       /*if (this.ReportEvent) {
            if (this.ReportEvent(row, item)) {
                return;
            }
        }*/

        await this.getPatientInfo(row.item.patientCode);
        
        this.repPatientCode = this.NotePatientInfo.patientCode
        this.repTransdate = item.transDate
        this.repVoid = item.isVoid
        this.repNotetime = item.noteTime ? item.noteTime : null


        if (location === 'chartreviewbydate') {
          this.repHeaderId = item.headerID
          this.repFormId = item.notesID
          this.repNoteName = item.description
          this.repTitle = this.getReportTitle(item.description, this.NotePatientInfo.firstName, this.NotePatientInfo.lastName, this.NotePatientInfo.patientCode)
        } else if (location === 'SchedulerNotesDB') {
          this.repHeaderId = item.headerID
          this.repFormId = item.notesID
          this.repNoteName = item.description
          this.repTitle = this.getReportTitle(item.description, this.NotePatientInfo.firstName, this.NotePatientInfo.lastName, this.NotePatientInfo.patientCode)
        }
        else if (location === 'DCSUpload') {
          this.repHeaderId = item.headerID
          this.repFormId = item.notesID
          this.repNoteName = item.formName
          this.repTitle = this.getReportTitle(item.formName, this.NotePatientInfo.firstName, this.NotePatientInfo.lastName, this.NotePatientInfo.patientCode)
        }         
        else {
          this.repHeaderId = item.Id,
          this.repFormId = row.notesId,
          this.repNoteName = row.description
          this.repTitle = this.getReportTitle(row.description, this.NotePatientInfo.firstName, this.NotePatientInfo.lastName, this.NotePatientInfo.patientCode)
        }
        this.isReportVisible = true
        EventBus.$emit('ShowWeel', false);
    },

    Upload(item){
      this.UploadIconEvent(item);
    },

    viewEligibility(row) {
        this.ViewEligibility(row)
    },

    Compare(itemA, itemB, key) {
      if(this.FieldsDate !== undefined && this.FieldsDate !== null){
        if(!this.FieldsDate.includes(key)){
          return false;
        } else {  
          let a = (itemA[key] === null || itemA[key] === ""?'00/00/0000 00:00:00':itemA[key]);
          let b = (itemB[key] === null || itemA[key] === ""?'00/00/0000 00:00:00':itemB[key]); 
          const dateA = new Date(moment(Utils.formatterDate(a, Utils.getFullDateTimeFormat())).format('MM/DD/YYYY HH:mm:ss')) 
          const dateB = new Date(moment(Utils.formatterDate(b, Utils.getFullDateTimeFormat())).format('MM/DD/YYYY HH:mm:ss'))
          return dateA - dateB;
        }
      }
    },

    tbodyRowClass(item) { 
      if(item != null){
         if(item.selected){
          return ["b-table-row-selected", "table-active", "cursor-pointer"]
        } else {
          return ["cursor-pointer"]
        }
      }
      },
      
    rowSelected(items) {     
   //   this.onRowSelected(items);
        if(this.onRowSelected) {
            this.onRowSelected(items);
        }
    },

    LocalrowClicked(item, index, event){     
      this.RowClick(item,index,event);
    },

    InfoEvent(row){
      this.InfoIconEvent(row);
    },

    viewButton(row,e) {      
      this.viewIconEvent(row,e);
      EventBus.$emit('shwoHideFavorite', false);
      EventBus.$emit('onUpdatedMenu', '');
    },

    ErrorLocal(row){
      this.Error(row);
    },

    WarningLocal(row){
      this.Warning(row);
    },


     editButton(row) {
        this.editIconEvent(row);
    },

    deleteButton(row) {
        this.deleteIconEvent(row);
    },
    selectRow(index){
      this.onSelectRow(index);
    },

    selectRow2(row) {
      this.$refs[this.refTable].selectRow(row)
    },
     
    unselectRow2(row) {
      this.$refs[this.refTable].unselectRow(row)
    },

    filtered(filteredItems) {
        this.onFiltered(filteredItems);
    },

    fpageChanged(page) {
        this.pageChanged(page);
    },
     fpageChangedSubItems(page) {
        this.pageChangedSubItems(page);
    },
    pageFunction(perpage) {
        this.perPageFunction(perpage);
    },
    otherButton(row) {
      this.otherIconEvent(row);
    },

    ondblClicked(item){    
        if (this.ondblClick) {
            this.ondblClick(item);
        } else if (this.viewIconEvent) {
            this.viewButton(item);
        } else if (this.editIconEvent) {
            this.editButton(item);
        }
    }

    },
  created() { 
     //this.fFields.unshift({ key: 'show_details'}); 
    if(this.editIconEvent || this.deleteIconEvent || this.viewIconEvent || this.otherIconEvent || this.emailIconEvent || this.iconSelected || this.UploadIconEvent) {     
      if(!this.isReadOnly){
        this.fFields.unshift({ key: 'actions', label: this.$tc('Shared.ActionsTxt',2)});
      }      
    }

    EventBus.$on("rowWasClicked", function (e) { 
      this.tbodyRowClass(e);      
     }.bind(this));
  }
}
</script>

<style scoped>

.checkboxBTN{
  background-color: #FFF  !important;
  border: 1px dashed #19BEE1 !important;
}

.checkboxBTN:hover{
  background-color: #19BEE1  !important;
  border: 1px dashed #FFF !important;
}

.checkboxBTN::before{
  color: #19BEE1;
  opacity: 0.5;
}
.checkboxBTN:hover::before{
  opacity: 1;
  color: #FFF;
}

.checkboxBTNChecked{
  background-color: #87e819 !important;
  border: 1px solid #FFF !important;
  font-weight: bold;
}

.checkboxBTNChecked:hover{
  background-color: #07ce00 !important;
}


.ActionsClass {
   width: 150px !important;
}
.TimeNotes{
 border: 1px solid #F3F3F3;
 background-color: #f9fbfc;
 color: #999;
 padding: 8px;
 border-radius: 6px;
 margin: 4px;
 cursor: pointer;
 transition: all 0.1s ease-out;
}
.addNotesBtn{
  background-color:#19BEE8;
  margin-right: 4px;
	border-radius:10px 2px;
	cursor:pointer;
  vertical-align: top;
	color:#ffffff;
	padding:4px 11px;
	text-decoration:none;
  border: 0;
}
.addNotesBtn:focus{
	background-color: #19BEE8 !important;
  color: #FFF !important;
}

.iconDisabled{
  opacity: 0.2;
  filter: grayscale(100%);
  }
  .btndisabled{
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
    background-color: gainsboro;
}

.text-danger {
  color: red;
}

</style>

